import ContributionDiscussion from './ContributionDiscussionContainer';

export default ContributionDiscussion;
